import React from 'react'
import PropTypes from 'prop-types'
import FadeIn from '../../molecules/Transitions/FadeIn'
import FlexRow from '../../molecules/FlexRow'
import Icon from '../../atoms/Icon'

function OpalTag ({ value, icon, iconSize, className, style }) {
  return (
    <FadeIn>
      <FlexRow className={className} style={style}>
        {icon ? (<Icon name={icon} customSize={iconSize} />) : null}
        <span>{value}</span>
      </FlexRow>
    </FadeIn>
  )
}

OpalTag.propTypes = {
  value: PropTypes.any,
  icon: PropTypes.string,
  iconSize: PropTypes.number,
  className: PropTypes.string,
  style: PropTypes.object
}

OpalTag.defaultProps = {
  iconSize: 12,
  className: 'radius-lg p-sm opal-surface-primary gap-sm'
}

export default OpalTag
